"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _admin = require("@/store/modules/admin");
var _clients = require("@/api/clients");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.startDate = '';
    this.endDate = '';
    this.list = [];
    this.loggedInUser = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      sort: 'id,DESC',
      filter: {
        enabled: '$eq'
      }
    };
  }
  created() {
    this.loggedInUser = _admin.AdminModule;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.fetchData();
    }
  }
  async fetchData() {
    this.listQuery.startDate = this.startDate;
    this.listQuery.endDate = this.endDate;
    const response = await (0, _clients.getClients)((0, _index.getQuery)(this.listQuery));
    this.list = response.data;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CustomerReviewTable',
  components: {}
})], default_1);
var _default = exports.default = default_1;